export default __webpack_public_path__ + "static/media/hedgehog.86fff396.png";